/* @flow */
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getAppsDataForCCXUI, setThor, updateEntitledProducts, getPDPDataForCCXUI, getAppsDataForCCXUIWithSophiaIntegration} from '../../actions/AppsActions';
import {getCatalogBannersDataForCCXUI} from '../../actions/CatalogBannersActions';
import {getFFCDataForAppPicker, getDataForAppPicker, getSingleAppPostPurchaseCVSData} from '../../actions/AppPickerActions';
import ErrorState from '../ErrorState/ErrorState';
import AppsAnalytics from '../../analytics/AppsAnalytics';
import '../../components/DownloadCoachMark/DownloadCoachMark.scss';
import appsUtil from '../../utils/AppsUtil';
import DeviceDetectionUtil from '../../utils/DeviceDetectionUtil';
import CSSUtil from '../../utils/CSSUtil';
import CompatibilityUtil from '../../utils/CompatibilityUtil';
import IncompatibleDialogUtil from '../../utils/IncompatibleDialogUtil';
import analyticsUtil from '../../utils/AnalyticsUtil';
import {
	planProductsMap,
	installationTab,
	starterTab,
	productIdToSapCode,
	PDPErrorTypes,
	AppsToCCXUICategoryMaping,
	CCWebRevampCategoryList,
	campaignId,
	singleAppPlans,
	desktopApps,
	eolProductInfo
} from '../../constants/appsConstants';
import {CCPP_APP_PICKER_QUERY_PARAM} from '../../constants/AppPicker/appPickerConstants';
import Url from '../../utils/Url';
import CCXUI from '@ccxi/ccxi-apps/src/components/apps';
import thorUtil from '../../utils/wam/ThorUtil';
import thorConnectionUtil from '../../utils/ThorConnectionUtil';
import InlineProductModel from '../Inline/InlineProductModel';
import AppLoader from '@ccxi/ccxi-apps/src/stores/appLoader';
import '../AppsPDP/AppsPDP.scss';
import './AppsController.scss';
import AppHandlers from '../../containers/AppHandlers/AppHandlers';
import CCXUIAppConfig from '@ccxi/ccxi-apps/src/stores/config';
import {ACTION_ID} from '@ccxi/ccxi-apps/src/utils/modelMapper/appModelMapper/appModelConstants';
import AppPickerMain from '../AppPickerPhotoPlan/AppPickerMain';
import layouts from '@ccxi/ccxi-apps/src/layouts';
import LoggerUtil from '@ccxi/ccxi-apps/src/utils/LoggerUtil';
import SkeletonModelMapper from '@ccxi/ccxi-apps/src/utils/modelMapper/skeletonModelMapper';
import {error} from '../../components/ErrorToast/ErrorToast';
import {thorAppsStatesCategory} from '../../constants/wamConstants';
import AppPickerController from '../AppPicker/AppPickerController';
import {isTestExperience, isControlExperience, isTestBExperience, isTestAExperience, isTestActive, _getVariationForCampaign} from '../../utils/TestUtil';
import AppPickerUtil from '../../utils/AppPicker/AppPickerUtil';
import InstallationController, {INSTALLATION_STATUSES} from '../InstallationController/InstallationController';
import GrowthUtil from '../../utils/GrowthUtil';
import queryString from 'query-string';
import {Toast} from '@react/react-spectrum/Toast';
import Wait from '@react/react-spectrum/Wait';

type Props = {
	history: Object,
	getAppsDataForCCXUI: Function,
	getFFCDataForAppPicker: Function,
	getDataForAppPicker: Function,
	getSingleAppPostPurchaseCVSData: Function,
	getCatalogBannersDataForCCXUI: Function,
	getAppsDataForCCXUIWithSophiaIntegration: Function,
	getPDPDataForCCXUI: Function,
	updateEntitledProducts: Function,
	setThor: Function,
	appsPanelSkeletonConfig: Object,
	sapCodeDataFetchStatus: Object,
	appsFFCProductList: Object,
	appPickerContentfulData: Object,
	entitlementData: Object,
	productsData: Object,
	entitledProducts: Object,
	cdnInfo: Object,
	environment: string,
	imsData: Object,
	locale: string,
	routing: boolean,
	routeSchema: Object,
	routeParams: Object,
	errorType: string,
	hasThor: boolean,
	intl: Object,
	error: Function,
	errorWithAction: Function,
	planCode: string,
	planStatus: string,
	profile: Object,
	customerSegment: string,
	profileTimeoutOrError: boolean,
	profileFetchFinished: boolean,
	location: Object,
	thorProductsList: Object,
	preFetchedRestAPIResponses: Function,
	addMiniPlanModal: ?Function;
};

type
State = {
	isMobileBreakPoint: boolean,
	isDnldUIReadyToRender: boolean
};

// const yourAppsTab = 'your-apps';
// const systemRequirementsTab = 'system-requirements';

class AppsController extends Component<Props, State> {
	dialogKey: number;
	tabClicked: boolean;
	profileTimeoutOrError: boolean;
	profileFetchFinished: boolean;
	starterPlanCode: ?string;
	currentPDPConfig: Object;
	dnldUIComponent: Object;
	pdpTabValues: Array<string>;
	wamCmdExecutedInAutoInstall: boolean;
	beforeIncompatibilityDialogOpen: Function;
	tryWamInstallation: Function;
	installationControllerInstance: InstallationController;
	loadHomePage: Function;
	installationModalOnClose: Function;
	executeCommand: Function;
	openPdpPage: Function;
	wamConnectionFinished: boolean;
	wamConnectionStatus: boolean;
	sentCategoryRevampAnalytics: boolean;

	constructor(props) {
		super(props);
		appsUtil.hasFeature('temp_enable_ccxi_logs') && LoggerUtil.setLogLevel(5);
		this.tabClicked = false;
		this.starterPlanCode = null;
		/**
		 * This holds the download page UI component as returned by InstallationControllerInstance on resolution of the promise.
		 * This has been maintained as state to cause a re-render on promise resolution
		 */
		this.dnldUIComponent = null;
		this.state = {
			isMobileBreakPoint: window.matchMedia && !window.matchMedia('(min-width: 768px)').matches,
			isDnldUIReadyToRender: false, /* State variable to keep track of when we need to render the dnldUIComponent returned by the Installation Controller */
			showWamToast: false
		};
		appsUtil.pageStartTime = new Date().getTime();
		appsUtil.locale = this.props.locale;
		appsUtil.planCode = this.props.planCode;
		this.currentPDPConfig = {};
		appsUtil.profile = props.profile;
		this.pdpTabValues = ['welcome', 'concierge', 'all'];
		thorUtil.formatMessage = this.props.intl.formatMessage;
		appsUtil.intl = this.props.intl;
		appsUtil.shouldRenderAppPickerPhotoPlan = this.shouldRenderAppPickerPhotoPlan.bind(this);
		appsUtil.addMiniPlanModal = this.props.addMiniPlanModal;

		this.installationModalOnClose = this.installationModalOnClose.bind(this);
		this.loadHomePage = this.loadHomePage.bind(this);
		this.beforeIncompatibilityDialogOpen = this.beforeIncompatibilityDialogOpen.bind(this);
		this.tryWamInstallation = this.tryWamInstallation.bind(this);
		this.executeCommand = this.executeCommand.bind(this);
		this.openPdpPage = this.openPdpPage.bind(this);

		AppHandlers.history = this.props.history;
		AppLoader.setLoadingText(this.props.intl.formatMessage({id: 'apps.ccxi.loader.text'}));
		const shouldWrapAtLowerBP = appsUtil.locale === 'ja';
		CCXUIAppConfig.init({
			getPDPDataCallback: this.openPDP.bind(this),
			analyticsCallback: AppHandlers.handleAnalytics.bind(AppHandlers),
			layouts,
			isNonDownloadableSurface: appsUtil.isMobileOrTab(),
			shouldWrapAtLowerBP,
			shortHeight: isTestBExperience(campaignId.bannerOnMobile),
			noBanner: isTestAExperience(campaignId.bannerOnMobile)
		});
		if (!thorConnectionUtil.shouldforceKaizenExperience() && !appsUtil.isMobileOrTab()) {
			this.initializeWAMWF();
		}
		if (this.props.customerSegment) {
			appsUtil.customerSegment = this.props.customerSegment;
		}

		this.installationControllerInstance = new InstallationController({
			intl: this.props.intl,
			locale: this.props.locale,
			environment: this.props.environment
		});

		this.wamCmdExecutedInAutoInstall = false;

		/* Deep linking of Urls based on sapcode and action
		 * CCH-7488
		 * Url pattern ?sapcode={sapcode}, ?sapcode={sapcode}&action=pdp/install/update/open
		 *
		 */
		if (this.props.location && this.props.location.search && Url.getParam('sapcode')) {
			const sapcodeInQueryParam = queryString.parse(this.props.location.search).sapcode;
			const actionInQueryParam = queryString.parse(this.props.location.search).action;
			const redirectionUrl = appsUtil.getProductUrl(sapcodeInQueryParam, actionInQueryParam);
			redirectionUrl && this.props.history.replace(redirectionUrl);
		}

		/*
		 * CCH-9010
		 * Redirect desktop app starter urls to installation urls where no corresponding single app plan exists
		 */
		if (appsUtil.hasFeature('temp_cch_9010') && appsUtil.isPostPurchaseUser() && !appsUtil.getSingleAppPostPurchasePlan()) {
			let productId = appsUtil.getPathData().product;
			if (!desktopApps.includes(productId)) {
				productId = appsUtil.getCCWebPathData().product;
			}
			else {
				this.props.history.replace(`/apps/all/${productId}/installation`);
			}
		}

		/*
		 * CCH-8203
		 * Split event
		 */
		if (appsUtil.hasFeature('temp_cch_8203_free')) {
			const appsAnalytics = new AppsAnalytics(this.props.environment);
			appsAnalytics.initAnalytics();
			appsAnalytics.genericAnalyticEvent({}, 'split', 'page', undefined, campaignId.trialToTWPFree, _getVariationForCampaign(campaignId.trialToTWPFree), undefined, 'Split', 'Apps');
		}
		if (appsUtil.hasFeature('temp_cch_8203_paid')) {
			const appsAnalytics = new AppsAnalytics(this.props.environment);
			appsAnalytics.initAnalytics();
			appsAnalytics.genericAnalyticEvent({}, 'split', 'page', undefined, campaignId.trialToTWPPaid, _getVariationForCampaign(campaignId.trialToTWPPaid), undefined, 'Split', 'Apps');
		}
		
		/*
		 * CCH-10455
		 * Split event
		 */
		if (isTestActive(campaignId.bannerOnMobile)) {
			const appsAnalytics = new AppsAnalytics(this.props.environment);
			appsAnalytics.initAnalytics();
			const variation = _getVariationForCampaign(campaignId.bannerOnMobile);
			appsAnalytics.genericAnalyticEvent({}, 'split', 'page', undefined, campaignId.bannerOnMobile, variation, undefined, 'Split', 'Apps');
		}
	}
	// executeCommand - This is for ccweb-revamp, similiar function is there in AppsPDP
	executeCommand() {
		if (this.props.hasThor) {
			const productFromFFC = appsUtil.appsFFCProductList[this.currentPDPConfig.id];
			if (productFromFFC && thorUtil.isConnected()) {
				const productFromThor = thorUtil.getWAMClient().getProduct(productFromFFC.id, productFromFFC.version);
				if (!productFromThor) {
					return;
				}
				const inlineProductModel = new InlineProductModel(productFromFFC.id, productFromFFC.version, this.currentPDPConfig.displayName, appsUtil.isAppEntitled(productFromFFC.id, 'desktop'));
				inlineProductModel.setShouldUpdateCTAOnFailure(false);
				switch (productFromThor.stateCategory) {
					case thorAppsStatesCategory.availableToInstall:
						inlineProductModel.install(null, 'install', 'got-it');
						break;
					case thorAppsStatesCategory.installed:
						inlineProductModel.launch(null, null, 'got-it');
						break;
					case thorAppsStatesCategory.availableToUpdate: {
						inlineProductModel.update(null, 'got-it');
					}
				}
			}
		}
	}

	openPdpPage(sapcode) {
		this.props.history.replace(appsUtil.getCCWebURL(sapcode, 'desktop'));
	}

	/**
	 * Handles inline product download in case of WAM workflow
	 *
	 * @param {string } sapcode Sapcode of the product
	 * @param {object} currentPDPConfig Details of the product
	 * @param {function} openInstallationDialog callback function to open download modal with thor workflow,
	 * used when inline download fails asynchronously
	 *
	 * @returns {wamConnectionEstablished} A boolean value indicating if wam connection was successfully established
	 * Used by Installation Controller to determine if download modal must be opened with thor workflow
	 */
	tryWamInstallation(sapcode, currentPDPConfig, openInstallationDialog) {
		// To handle re-render case if command has already pushed and cancelled.
		if (this.wamCmdExecutedInAutoInstall) {
			return true;
		}

		if (thorUtil.isAnOperationHappeningOnProduct(currentPDPConfig.id, currentPDPConfig.version)) { // To cater if a product is already being installed
			this.wamCmdExecutedInAutoInstall = true;
			this.props.history.replace(appsUtil.getCCWebURL(sapcode));
			return true;
		}

		const thorProduct = thorUtil.getWAMClient().getProduct(currentPDPConfig.id, currentPDPConfig.version);
		const inlineProductModel = new InlineProductModel(currentPDPConfig.id, currentPDPConfig.version, currentPDPConfig.displayName, thorUtil.isProductEntitled(thorProduct));
		inlineProductModel.fallBackOnFailure = openInstallationDialog;

		inlineProductModel.cmdSuccessCallback = () => {
			this.props.history.replace(appsUtil.getCCWebURL(sapcode));
		};
		if (thorUtil.isActionSupportedOnProduct(currentPDPConfig.id, currentPDPConfig.version, ACTION_ID.INSTALL)) {
			this.wamCmdExecutedInAutoInstall = true;
			inlineProductModel.autoInstall();
			return true;
		}
		if (thorUtil.isActionSupportedOnProduct(currentPDPConfig.id, currentPDPConfig.version, ACTION_ID.UPDATE)) {
			this.wamCmdExecutedInAutoInstall = true;
			inlineProductModel.autoUpdate();
			return true;
		}
		if (thorUtil.isActionSupportedOnProduct(currentPDPConfig.id, currentPDPConfig.version, ACTION_ID.OPEN)) {
			this.wamCmdExecutedInAutoInstall = true;
			inlineProductModel.autoLaunch();
			return true;
		}
		return false;
	}

	clientStateHandler(isThorPresent) {
		thorUtil.getWAMClient().reset();
		this.props.error(this.props.intl.formatMessage({id: 'apps.thorDisconnect.msg'}));
		this.props.setThor(isThorPresent);
	}

	componentWillUnmount() {
		let element = document.querySelector('.cchome-apps');
		if (element != null) {
			element.scrollTop = 0;
		}

		element = document.getElementById('footer');
		if (element != null) {
			element.classList.remove('footer_small_device');
		}

		element = document.getElementById('root');
		if (element != null) {
			element.classList.remove('all_apps_page');
		}

		if (document.querySelector('#root')) {
			document.querySelector('#root').style.overflow = '';
			document.querySelector('html').style.overflow = '';
		}
		this.installationControllerInstance.hideModalContainer('dialogKey');
		// Before unmounting, set document title to "Adobe Creative Cloud"
		document.title = this.props.intl.formatMessage({id: 'apps.document.title'});
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.profileTimeoutOrError) {
			this.profileTimeoutOrError = nextProps.profileTimeoutOrError;
		}
		if (!this.profileTimeoutOrError) {
			if (nextProps.profileFetchFinished) {
				this.profileFetchFinished = nextProps.profileFetchFinished;
			}
			if (nextProps.planStatus) {
				appsUtil.planStatus = nextProps.planStatus;
			}
			if (nextProps.customerSegment) {
				appsUtil.customerSegment = nextProps.customerSegment;
			}
			if (nextProps.planCode) {
				appsUtil.planCode = nextProps.planCode;
			}
		}
		return true;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.profile !== this.props.profile) {
			appsUtil.profile = nextProps.profile;
			this.props.updateEntitledProducts();
		}
	}

	sendActivationAnalytic(type: string, testValue?: string) {
		const appsAnalytics = new AppsAnalytics(this.props.environment);
		appsAnalytics.initAnalytics();
		switch (type) {
			case 'split':
				appsAnalytics.genericAnalyticEvent({}, 'split', 'page', undefined, '20190201-App-Picker', testValue, undefined, 'Split', 'App Picker');
				break;
		}
	}

	setFailStateForUpdates(status) {
		const {intl, hasThor} = this.props;
		const ccProductConfig = appsUtil.getFFCProductConfigBySapCode('KCCC');

		const failState = {
			status: !!status,
			heading: intl.formatMessage({id: 'apps.category.updates.wam.fail.heading'}),
			description: intl.formatMessage({id: 'apps.category.updates.wam.fail.description'}),
			CTALabel: intl.formatMessage({id: hasThor ? 'apps.category.updates.wam.fail.thor.CTA' : 'apps.category.updates.wam.fail.kaizen.CTA'}),
			getImageUrl: () => appsUtil.getProductIcon(ccProductConfig),
			onCTAClick: () => AppHandlers.openCreativeCloud(),
			ctaActionId: hasThor ? 'open-creative-cloud' : 'download-creative-cloud',
			pageType: hasThor ? 'no-wam-connection' : 'ccd-not-detected',
			app: ccProductConfig && appsUtil.CCXUIAppStore[`KCCC_${ccProductConfig.version}`]
		};
		SkeletonModelMapper.showWaitIconForUpdates(false);
		SkeletonModelMapper.setWamFailState(failState);
	}

	onWamConnectionFinished(isSuccess) {
		this.setFailStateForUpdates(!isSuccess);
		this.wamConnectionFinished = true;
		this.wamConnectionStatus = isSuccess;
		if (this.state.showWamToast) {
			this.setState({showWamToast: false});
		}
	}

	initializeWAMWF() {
		thorUtil.initializeWAMClient(this.props.thorProductsList, isSuccess => this.onWamConnectionFinished(isSuccess));
		thorUtil.getWAMClient().addListenerForClientState(this.clientStateHandler.bind(this));
	}

	componentDidMount() {
		if (document.querySelector('#root')) {
			document.querySelector('html').style.overflow = 'hidden';
		}
		if (appsUtil.isCCHInLMS()) {
			const cchInCanvas = document.getElementsByClassName('adjust-cchome-in-canvas')[0];
			if (cchInCanvas) {
				const parentOfCCHInCanvas = cchInCanvas.parentElement;
				if (parentOfCCHInCanvas) {
					parentOfCCHInCanvas.classList.add('adjust-cchome-apps-in-canvas');
				}
			}
		}
		appsUtil.pageloadTime = new Date().getTime();
		const pathData = appsUtil.getPathData();
		const pathDataCCWeb = appsUtil.getCCWebPathData();
		const appsAnalytics = new AppsAnalytics(this.props.environment);
		appsUtil.setVisitorGuid(appsAnalytics.getVisitorGuid());
		if (this.props.appsPanelSkeletonConfig && this.props.appsPanelSkeletonConfig !== null && this.props.appsFFCProductList && this.props.appsFFCProductList !== null) {
			/*
				Redirection will take place from here if the data was already fetched before this component was mounted,
				and componentDidUpdate is not expected to be called because of this reason.
				For eg: when a user downloads a product by clicking on Download button that appears as part of search result
			*/
			// check new installation url and open installation modal
			this.reRouteToCCWebRevampURL(this.props);
			this.checkNewInstallationRoute(this.props);
		}
		else {
			// Determine if this is the post-purchase page of a plan and determine the value of this plan (starterPlan)
			let starterPlan = (pathData.mainAppsTab === starterTab || pathData.pdpTab === installationTab) && pathData.product ? pathData.product.toLowerCase() : '';
			if (pathDataCCWeb.isPDP && Url.getParam('action') === 'install') {
				starterPlan = pathDataCCWeb.product;
			}
			if (!starterPlan && appsUtil.sessionStorageGet('isCCPPStarter')) {
				starterPlan = 'ccpp';
			}

			// Initiate appropriate actions
			if (AppPickerUtil.isNUJAllAppsExperience() || AppPickerUtil.isNUJSubstancePlanExperience()) {
				// Fetch only app picker AEM data
				starterPlan = AppPickerUtil.getAppPickerPlan();
				this.props.getDataForAppPicker(this.props.imsData, this.props.locale, starterPlan);
			}
			else {
				// Fetch skeleton data
				if (appsUtil.hasFeature('temp_test_render_sophia_latency')) {
					this.props.getAppsDataForCCXUIWithSophiaIntegration(this.props.locale, this.props.imsData, this.props.planCode, starterPlan, this.props.preFetchedRestAPIResponses);
				}
				else {
					this.props.getCatalogBannersDataForCCXUI(this.props.locale, this.props.imsData);
					this.props.getAppsDataForCCXUI(this.props.locale, this.props.imsData, this.props.planCode, starterPlan, this.props.preFetchedRestAPIResponses);
				}

				// Fetch app picker AEM data
				if (AppPickerUtil.isSingleAppPlanNUJExp()) {
					this.props.getSingleAppPostPurchaseCVSData(this.props.locale, Url.getParam('plan') || appsUtil.getSingleAppPostPurchasePlan());
				}
				if (AppPickerUtil.isNujM3PhotoPlanTestExperience()) {
					starterPlan = AppPickerUtil.getAppPickerPlan();
					this.props.getDataForAppPicker(this.props.imsData, this.props.locale, starterPlan);
				}
			}
		}
	}

	sendInitAnalyticEvent() {
		const analyticObject = {
			event: {
				workflow: 'Apps',
				subcategory: 'Initialize',
				type: 'render',
				subtype: 'apps-controller',
			}
		};
		AppHandlers.handleAnalytics({componentParams: {}, analyticObjectList: [analyticObject]});
	}

	installationModalOnClose() {
		const source = Url.getParam('source');
		const pathDataCCWeb = appsUtil.getCCWebPathData();

		if (source === 'appPicker') { // take to iPad app picker page on closing email me link page
			this.props.history.goBack();
		}
		else if (pathDataCCWeb.isPDP && pathDataCCWeb.product) {
			this.props.history.push(appsUtil.getCCWebURL(productIdToSapCode[pathDataCCWeb.product]));
		}
		else {
			this.props.history.push(appsUtil.getCCWebURL());
		}
	}

	isCCPPWorkflow(starterPlanCode) {
		return starterPlanCode === 'ccpp' || starterPlanCode === 'ccppn' || Url.getParam('plan') === 'ccpp' || Url.getParam('plan') === 'ccppn';
	}

	initiateAppDownloadWorkflow(sapcode) {
		this.installationControllerInstance.initiateAppDownloadWorkflow({
			sapcode,
			parentContext: this,
			onCloseHandler: this.installationModalOnClose,
			loadHomePage: this.loadHomePage,
			tryWamInstallation: this.tryWamInstallation,
			beforeIncompatibilityDialogOpen: this.beforeIncompatibilityDialogOpen,
			isCCPPWorkflow: this.isCCPPWorkflow(this.starterPlanCode),
			executeCommand: this.executeCommand,
			openPdpPage: this.openPdpPage,
			/* Determines if dialog should be opened or the client will itself render the download page component */
			shouldReturnDnldComponent: AppPickerUtil.isSingleAppPlanNUJExp(),
			history: this.props.history
		}).then((statusObj) => {
			const {status, dnldUIComponent} = statusObj;
			if (status === INSTALLATION_STATUSES.SUCCESS.INSTALLATION_UI_COMPONENT_READY_TO_MOUNT) {
				this.dnldUIComponent = dnldUIComponent;
				this.setState({isDnldUIReadyToRender: true});
			}
		},
		(err) => {
			if (err === INSTALLATION_STATUSES.ERROR.FETCH_FFC_DATA_FAILED || err === INSTALLATION_STATUSES.ERROR.FFC_DATA_INVALID) {
				error(this.props.intl.formatMessage({id: PDPErrorTypes.PDPEndpointDown.messageId}), {
					msgId: PDPErrorTypes.PDPEndpointDown.errorId, variant: 'default', timeout: 5000
				});
			}
			this.installationModalOnClose();
		});
	}

	beforeIncompatibilityDialogOpen(sapcode, pdpType) {
		this.props.history.replace(appsUtil.getCCWebURL(sapcode, pdpType, false, false));
	}

	allAppsPathCheck() {
		if ((window.location.pathname.toLowerCase() === '/apps/all/desktop'
		|| window.location.pathname.toLowerCase() === '/apps/all/mobile'
		|| window.location.pathname.toLowerCase() === '/apps/all/web')) {
			const element = document.getElementById('footer');
			if (element !== null) {
				element.classList.add('footer_small_device');
			}
			const element2 = document.getElementById('root');
			if (element2 !== null) {
				element2.classList.add('all_apps_page');
			}
		}
		else {
			const element = document.getElementById('footer');
			if (element !== null) {
				element.classList.remove('footer_small_device');
			}
			const element2 = document.getElementById('root');
			if (element2 !== null) {
				element2.classList.remove('all_apps_page');
			}
		}
	}

	componentDidUpdate(prevProps) {
		this.allAppsPathCheck();
		const element = document.querySelector('.cchome-apps');
		if (element != null) {
			element.scrollTop = 0;
		}
		if (this.props.appsFFCProductList !== undefined && prevProps.appsFFCProductList !== this.props.appsFFCProductList && (appsUtil.isCVSMainFallback || appsUtil.isFFCFallback)) {
			let subtype = '';
			if (appsUtil.isCVSMainFallback) {
				subtype = 'cvs-main';
				if (appsUtil.hasFeature('temp_contentful_to_aem_migration')) {
					subtype = 'aem-main';
				}
			}
			if (appsUtil.isFFCFallback) {
				const ffcError = this.props.appsFFCProductList ? 'ffc' : 'ffc-fallback';
				subtype += (subtype !== '') ? `,${ffcError}` : ffcError;
			}
			this.onError(subtype);
		}

		if (this.props.appsPanelSkeletonConfig && this.props.appsPanelSkeletonConfig !== null && this.props.appsFFCProductList && this.props.appsFFCProductList !== null) {
			/*
				Once all compulsory data (cvs skeleton data and ffc latest version data) is fetched, execute below
				Note: In case of NUJ app picker for all apps and photo plan, execution will never come here because,
				appsPanelSkeletonConfig is never fetched as part of NUJ
			*/

			if (prevProps.appsPanelSkeletonConfig !== this.props.appsPanelSkeletonConfig) {
				appsUtil.printTimeEndLog('page_load_time');
				// send initialize event very first time before changing the url
				appsUtil.pageloadTime = new Date().getTime() - appsUtil.pageloadTime;
				appsUtil.printLog(`load Time: ${appsUtil.pageloadTime}`);
				this.sendInitAnalyticEvent();
				const appsAnalytics = new AppsAnalytics(this.props.environment);
				appsUtil.setVisitorGuid(appsAnalytics.getVisitorGuid());
				// handling a case when wam connection resolved before appsPanelSkeleton
				if (this.wamConnectionFinished) {
					this.setFailStateForUpdates(!this.wamConnectionStatus);
				}
				else {
					if (appsUtil.hasThor) {
						this.setState({showWamToast: true});
						SkeletonModelMapper.showWaitIconForUpdates(true);
						setTimeout(() => {
							if (!this.wamConnectionFinished) {
								this.setFailStateForUpdates(true);
								this.setState({showWamToast: false});
							}
						}, 10000);
					}
					else {
						this.setFailStateForUpdates(true);
					}
				}
			}

			this.reRouteToCCWebRevampURL(prevProps);
			this.checkNewInstallationRoute(prevProps);

			if (prevProps.appsPanelSkeletonConfig !== this.props.appsPanelSkeletonConfig || ((prevProps.routeParams.mainAppsTab !== this.props.routeParams.mainAppsTab) && appsUtil.starterRedirectPlanCode === null)) {
				/*
					We come here under either of the 2 cases:
					1. The CVS skeleton data just came in
					2. URL changed and this change was not because of redirection from a post-purchase photo plan starter page to the installation page

					Basically the aim is that we should enter this if block only once in a given workflow
				*/
				const productParameter = this.props.routeParams.product;
				if (appsUtil.getPathData().mainAppsTab === starterTab && productParameter
				&& planProductsMap.hasOwnProperty(productParameter.toLowerCase())) {
					const productName = productParameter.toLowerCase();
					appsUtil.isStarterPlanRedirect = true;
					appsUtil.starterRedirectPlanCode = productName;
					// prevent redirection from starter/ccpp in case of nuj
					if (!Url.getParam('isStarter') && !AppPickerUtil.isNujM3PhotoPlanTestExperience()) {
						// determine plan purchased by user.
						appsUtil.sessionStorageSet('userStarterPlanCode', appsUtil.starterRedirectPlanCode);
						if (!this.shouldRenderAppPickerPhotoPlan()) {
							appsUtil.sessionStorageRemove('isCCPPStarter');
							this.starterPlanCode = productName;

							/*
								Determine where to redirect the photo plan user to and store in productToDownload (the product id) and sapCodeToDownload (the sap code)
							*/
							const productToDownloadObj = planProductsMap[productParameter.toLowerCase()];
							let productToDownload = productToDownloadObj.primaryProductId;
							let sapCodeToDownload = productToDownloadObj.primaryProductSapCode;
							const isProductSupported = sapCode => appsUtil.appsFFCProductList[sapCode] && (CompatibilityUtil.isAppSupported(sapCode) || CompatibilityUtil.isAnyOlderVersionSupported(sapCode));
							if (!isProductSupported(productToDownloadObj.primaryProductSapCode)
							&& productToDownloadObj.secondaryProductId && productToDownloadObj.secondaryProductSapCode
							&& isProductSupported(productToDownloadObj.secondaryProductSapCode)) {
								productToDownload = productToDownloadObj.secondaryProductId;
								sapCodeToDownload = productToDownloadObj.secondaryProductSapCode;
							}
							const url = appsUtil.getInstallationModalUrl(
								{sapCode: sapCodeToDownload, plan: productName, source: 'apps'},
								{isStarter: true, category: 'all', subCategory: 'desktop', isCategoryPath: true}
							);
							this.props.history.replace(url);

							if ((appsUtil.appsFFCProductList[sapCodeToDownload] && !(CompatibilityUtil.isAppSupported(sapCodeToDownload) || CompatibilityUtil.isAnyOlderVersionSupported(sapCodeToDownload))) && !appsUtil.isMobileOrTab()) {
								const incompatibilityDialogModel = appsUtil.CCXUIAppStore[`${sapCodeToDownload}_${appsUtil.appsFFCProductList[sapCodeToDownload].version}`];
								this.installationControllerInstance.showIncompatibilityDialog(incompatibilityDialogModel);
							}
							appsUtil.isAutoNonStarterInstallation = false;
							this.sendAutoDownloadClickEvent(productToDownload.toLowerCase(),true);
						}
					}
					else if (!AppPickerUtil.isNujM3PhotoPlanTestExperience()) {
						appsUtil.isAutoNonStarterInstallation = false;
					}
				}
				else if ((appsUtil.getPathData().mainAppsTab === starterTab || (appsUtil.getPathData().pdpTab && appsUtil.getPathData().pdpTab === installationTab)) && productParameter && this.tabClicked === false && appsUtil.appsFFCProductList[productIdToSapCode[productParameter.toLowerCase()]]) {
				// In case of single app plan
					if (appsUtil.getPathData().mainAppsTab === starterTab) {
						const productName = productParameter.toLowerCase();
						// determine plan purchased by user.
						appsUtil.sessionStorageSet('userStarterPlanCode', productName);
					}
					appsUtil.isAutoNonStarterInstallation = !(appsUtil.getPathData().mainAppsTab === starterTab);
					appsUtil.starterRedirectPlanCode = productParameter.toLowerCase();
					// this.starterPlanCode = appsUtil.starterRedirectPlanCode;
					this.sendAutoDownloadClickEvent(productParameter.toLowerCase(),true);
				}
				else {
					// check if any old url to new url redirect not happening
				}
				// don't move tabClicked up this is to check if user has come here first time,so setting it true before exiting the function
				this.tabClicked = true;
			}
		}

		if (AppPickerUtil.isNUJAppPickerExperience() || AppPickerUtil.isSingleAppPlanNUJExp()) {
			if (this.props.appPickerContentfulData && this.props.appPickerContentfulData !== null
				&& prevProps.appPickerContentfulData !== this.props.appPickerContentfulData
				&& appsUtil.isCVSAppPickerDataFallback) {
				// Send event once when call made for CVS data for app picker and it failed and there was a fallback to apps-assets fallback data
				appsUtil.hasFeature('temp_contentful_to_aem_migration') ? this.onError('aem-nuj') : this.onError('cvs-nuj');
			}
			else if (
				appsUtil.isCVSAppPickerDataFallback
				&& this.props.appPickerContentfulData === null
				&& prevProps.errorType !== this.props.errorType
				&& this.props.errorType === '500') {
				appsUtil.hasFeature('temp_contentful_to_aem_migration') ? this.onError('aem-nuj-fallback') : this.onError('cvs-nuj-fallback');
			}
		}

		if (Url.getParam('action') !== 'install') {
			// resetStarterPlanAndCloseDialog function in turn calls installationModalOnClose which push catalog/pdp url. Stubing calling installationModalOnClose from here to fix CCH-8089.
			this.installationControllerInstance.resetStarterPlanAndCloseDialog(this.installationModalOnClose, appsUtil.hasFeature('temp_bug_fix_cch_8089') && true);
		}

		const section = appsUtil.getCCWebPathData().sectionId;
		const textId = section === 'updates' ? 'apps.ccxi.loader.text.updates' : 'apps.ccxi.loader.text';
		AppLoader.setLoadingText(this.props.intl.formatMessage({id: textId}));
	}

	shouldRenderWamState() {
		const path = appsUtil.getCCWebPathData();
		return this.state.showWamToast && Url.getParam('action') !== 'install' && !path.isPDP && path.sectionId === 'all';
	}

	renderWamConnnectionToast() {
		return this.shouldRenderWamState() ? (
			<Toast className='wam-connection-toast'>
				<div className='wait-icon-wrapper'><Wait className='wait-icon' size='S'/></div>
				<div className='toast-content'>{this.props.intl.formatMessage({id: 'apps.wam.loader.toast'})}</div>
			</Toast>) : null;
	}

	isInvalidDesktopProductId(productId) {
		const productConfig = appsUtil.getFFCProductConfig(productId);
		return !productConfig || appsUtil.getProductPlatform(productConfig) !== 'desktop';
	}

	reRouteToCCWebRevampURL(prevProps) {
		let productName;
		if (prevProps && prevProps.routeParams && prevProps.routeParams.product) {
			productName = prevProps.routeParams.product.toLowerCase();
		}
		const pathData = appsUtil.getPathData();
		const pathDataCCWeb = appsUtil.getCCWebPathData();
		const productIdParam = Url.getParam('productId');
		const oldProductId = pathDataCCWeb.isPDP ? '' : pathData.product;
		const productId = pathDataCCWeb.isPDP ? pathDataCCWeb.product : (oldProductId || productIdParam);
		const category = AppsToCCXUICategoryMaping[pathData.mainAppsTab] || 'all';
		let productConfig = appsUtil.getFFCProductConfig(productId);
		let isDesktopProduct = productConfig && productConfig.type && productConfig.type.toLowerCase() === 'desktop';
		if (AppPickerUtil.isSingleAppPlanNUJExp()) {
			if (singleAppPlans.includes(productId)) {
				isDesktopProduct = true;
				productConfig = {
					type: 'desktop'
				};
			}
			else {
				return;
			}
		}

		if (!pathDataCCWeb.isPDP && productConfig) {
			// This is an old url and the productId in it is valid.
			// Need to redirect to the new URL.
			const subCategory = appsUtil.getSubCategory(category, productIdToSapCode[productId]);
			if ((pathData.mainAppsTab === starterTab || pathData.pdpTab === installationTab) && isDesktopProduct) {
				this.props.history.replace(appsUtil.getInstallationModalUrl(
					{sapCode: productIdToSapCode[productId], plan: productName, source: 'apps'},
					{isStarter: pathData.mainAppsTab === starterTab, category, subCategory, isCategoryPath: true}
				));
			}
			else {
				this.props.history.replace(`/apps/${category}/${subCategory}/pdp/${productId}`);
			}

			if (prevProps.appsPanelSkeletonConfig !== this.props.appsPanelSkeletonConfig) {
				this.sendAutoDownloadClickEvent(productId,(pathData.mainAppsTab === starterTab));
			}
		}
		else if (productIdParam && this.isInvalidDesktopProductId(productIdParam)) {
			if (appsUtil.hasFeature('temp_9515_bug_fix') && appsUtil.isValidCCHomeProduct(productIdParam)) {
				this.showInvalidProductIdError(productIdParam);
			}
			this.props.history.replace(`/apps/${category}/${appsUtil.getSubCategory(category, productIdToSapCode[productIdParam])}`);
		}
		else {
			if (appsUtil.hasFeature('temp_cch_10838')) {
				if (oldProductId
					&& !(['desktop', 'web', 'mobile'].includes(oldProductId))
					&& this.props.appsFFCProductList
					&& !(pathData.mainAppsTab === starterTab && planProductsMap[pathData.product])
					&& (
						!productIdToSapCode[oldProductId]
						|| !appsUtil.disableProduct(productIdToSapCode[oldProductId])
						|| (productIdToSapCode[oldProductId] && !appsUtil.getFFCProductConfig(oldProductId))
					)
				) {
					this.showInvalidProductIdError(oldProductId);
					this.props.history.replace(`/apps/${category}/${appsUtil.getSubCategory(category, productIdToSapCode[oldProductId])}`);
				}
				else if (pathDataCCWeb.sectionId
					&& (
						pathData.mainAppsTab !== starterTab
						|| (pathData.mainAppsTab === starterTab && !planProductsMap[pathData.product] && !productIdToSapCode[pathData.product]))
					&& CCWebRevampCategoryList.indexOf(pathDataCCWeb.sectionId) < 0
				) {
					// redirect for wrong product in url
					this.props.history.replace(`/apps/${category}/${appsUtil.getSubCategory(category)}`);
				}
			}
			else {
				if (oldProductId && productIdToSapCode[oldProductId] && !appsUtil.getFFCProductConfig(oldProductId)) {
					this.showInvalidProductIdError(oldProductId);
					this.props.history.replace(`/apps/${category}/${appsUtil.getSubCategory(category, productIdToSapCode[oldProductId])}`);
				}
				else if (pathDataCCWeb.sectionId && (pathData.mainAppsTab !== starterTab || (pathData.mainAppsTab === starterTab && !planProductsMap[pathData.product] && !productIdToSapCode[pathData.product])) && CCWebRevampCategoryList.indexOf(pathDataCCWeb.sectionId) < 0) {
					// redirect for wrong product in url
					this.props.history.replace(`/apps/${category}/${appsUtil.getSubCategory(category)}`);
				}
			}
		}
	}

	showInvalidProductIdError(productId) {
		if (appsUtil.hasFeature('temp_cch_10838') && (!productIdToSapCode[productId] || appsUtil.disableProduct(productIdToSapCode[productId]))) {
			let eolDialogInfo;
			if (eolProductInfo[productId]) {
				eolDialogInfo = eolProductInfo[productId];
			}
			else {
				eolDialogInfo = eolProductInfo.generic;
			}
			if (!IncompatibleDialogUtil.EOLDialog) {
				IncompatibleDialogUtil.renderEOLDialog(
					eolDialogInfo.errorTitle,
					eolDialogInfo.errorMessage
				);
			}
		}
		else if (appsUtil.isSubstanceDesktopApp(productIdToSapCode[productId])) {
			error(this.props.intl.formatMessage({id: 'apps.pdp.noFFCDataError.CCXUI.substanceApp'}), {msgId: 'notEligibleForSBST',variant: 'default',timeout:7000});
		}
		else {
			error(this.props.intl.formatMessage({id: 'apps.pdp.noFFCDataError.CCXUI'}), {msgId: 'notEligible',variant: 'default',timeout:7000});
		}
	}

	checkNewInstallationRoute(prevProps) {
		const pathDataCCWeb = appsUtil.getCCWebPathData();
		if (!(this.installationControllerInstance.dialogKey || (this.state.isDnldUIReadyToRender && !this.installationControllerInstance.shouldReRenderDownloadComponent()))
			&& ((pathDataCCWeb.isPDP && pathDataCCWeb.product) || Url.getParam('productId'))
			&& Url.getParam('action') === 'install') {
			const sapcode = productIdToSapCode[pathDataCCWeb.product || Url.getParam('productId')];
			this.initiateAppDownloadWorkflow(sapcode);
		}
		else {
			this.installationControllerInstance.hideModalContainer('informationDialogKey');
			if (!pathDataCCWeb.isPDP) {
				this.installationControllerInstance.hideIncompatibilityDialog();
			}
			// Close open dialogs like sendlink when url changes
			if (prevProps.location.pathname !== this.props.location.pathname) {
				const pathData = appsUtil.getCCWebPathData(prevProps.location.pathname);
				const sapcode = productIdToSapCode[pathData.product];
				appsUtil.informationDialogStore[sapcode] && appsUtil.informationDialogStore[sapcode].hide();
				if (AppHandlers.sendLinkDialog) {
					AppHandlers.sendLinkDialog.hide();
					AppHandlers.sendLinkDialog = null;
				}
			}
		}
	}

	sendAutoDownloadClickEvent(productToDownload,isPostPurchase) {
		const appsAnalytics = new AppsAnalytics(this.props.environment);
		const sapCode = productIdToSapCode[productToDownload];
		const productConfig = appsUtil.appsFFCProductList[sapCode];
		const hasThor = appsUtil.hasThor;
		let label = (appsUtil.hasThor && !appsUtil.isMobileOrTab()) ? 'install' : 'download';
		appsAnalytics.initAnalytics();
		if (productConfig) {
			const tileConfig = appsUtil.getTileConfig(productConfig);
			if (!appsUtil.displayTile(tileConfig.sapCode, tileConfig.type) || !CompatibilityUtil.isAppSupported(tileConfig.sapCode)) {
				label = `${label}-incompatible`; // send app compatibility info for apps picker also
			}
			const sapCode = tileConfig.sapCode;
			let isAnalyticsSent = false;
			if (sapCode === 'LRCC') { // Lightroom product
				if (!CompatibilityUtil.isAppSupported(sapCode)) { // latest version is incompatible previous version might be supported
					label = (appsUtil.hasThor && !appsUtil.isMobileOrTab()) ? 'install' : 'download';
					if (CompatibilityUtil.isAnyOlderVersionSupported(sapCode)) {
						if (appsUtil.starterRedirectPlanCode === 'ccpp' || appsUtil.starterRedirectPlanCode === 'ccppn') { // LR CC but plan is Lightroom classic
							const eventConfig = analyticsUtil.getEventConfigOnCTAClickOfOsDeprecation({
								eventSubType: label,
								hasThor,
								isSourcePDP: false,
								isPostPurchase,
								componentVersion: 'auto-previous-lr-cc',
								outcome: 'true-lr-cc'
							});
							analyticsUtil.osDeprecationEventConfig = eventConfig;
							appsAnalytics.onCTAClickOfOSDeprecation(tileConfig, eventConfig);
							isAnalyticsSent = true;
						}
					}
					else { // no version is supported
						if (appsUtil.starterRedirectPlanCode === 'ccpp' || appsUtil.starterRedirectPlanCode === 'ccppn') { // LR CC but plan is Lightroom classic
							if (!CompatibilityUtil.isAnyOlderVersionSupported('LTRM')) {
								const eventConfig = analyticsUtil.getEventConfigOnCTAClickOfOsDeprecation({
									eventSubType: `${label}-incompatible`,
									hasThor,
									isSourcePDP: false,
									isPostPurchase,
									outcome: 'false-lr-cc/false-older-lr-classic'
								});
								analyticsUtil.osDeprecationEventConfig = eventConfig;
								appsAnalytics.onCTAClickOfOSDeprecation(tileConfig, eventConfig);
								isAnalyticsSent = true;
							}
						}
					}
				}
			}

			else if (sapCode === 'LTRM') { // LR classic product
				label = (appsUtil.hasThor && !appsUtil.isMobileOrTab()) ? 'install' : 'download';
				if (appsUtil.starterRedirectPlanCode === 'ccpp' || appsUtil.starterRedirectPlanCode === 'ccppn') { // Plan is also for Lightroom classic
					if (!CompatibilityUtil.isAppSupported(sapCode)) {
						if (CompatibilityUtil.isAnyOlderVersionSupported(sapCode)) {
							const eventConfig = analyticsUtil.getEventConfigOnCTAClickOfOsDeprecation({
								eventSubType: label,
								hasThor,
								isSourcePDP: false,
								isPostPurchase,
								componentVersion: 'auto-previous-lr-classic',
								outcome: 'false-lr-cc/true-older-lr-classic'
							});
							analyticsUtil.osDeprecationEventConfig = eventConfig;
							appsAnalytics.onCTAClickOfOSDeprecation(tileConfig, eventConfig);
							isAnalyticsSent = true;
						}
					}
					else {
						const eventConfig = analyticsUtil.getEventConfigOnCTAClickOfOsDeprecation({
							eventSubType: label,
							hasThor,
							isSourcePDP: false,
							isPostPurchase,
							componentVersion: 'auto-current-lr-classic',
							outcome: 'false-lr-cc/true-current-lr-classic'
						});
						analyticsUtil.osDeprecationEventConfig = eventConfig;
						appsAnalytics.onCTAClickOfOSDeprecation(tileConfig, eventConfig);
						isAnalyticsSent = true;
					}
				}
			}
			if (!isAnalyticsSent) { // to cater another sapcode and plan.
				if (CompatibilityUtil.isAppSupported(sapCode)) {

				}
				else {
					label = (appsUtil.hasThor && !appsUtil.isMobileOrTab()) ? 'install' : 'download';
					if (CompatibilityUtil.isAnyOlderVersionSupported(sapCode)) {
						const eventConfig = analyticsUtil.getEventConfigOnCTAClickOfOsDeprecation({
							eventSubType: label,
							hasThor,
							isSourcePDP: false,
							isPostPurchase
						});
						appsAnalytics.onCTAClickOfOSDeprecation(tileConfig, eventConfig);
					}
					else {
						const eventConfig = analyticsUtil.getEventConfigOnCTAClickOfOsDeprecation({
							eventSubType: `${label}-incompatible`,
							hasThor,
							isSourcePDP: false,
							isPostPurchase
						});
						appsAnalytics.onCTAClickOfOSDeprecation(tileConfig, eventConfig);
					}
				}
			}
		}
		else {
			const eventConfig = analyticsUtil.getEventConfigOnCTAClickOfOsDeprecation({
				eventSubType: `${label}-incompatible`,
				hasThor,
				isSourcePDP: false,
				isPostPurchase
			});
			appsAnalytics.onCTAClickOfOSDeprecation({sapCode}, eventConfig);
		}
	}

	openPDP() {
		const sapcode = productIdToSapCode[appsUtil.getCCWebPathData().product];
		const isFFCDataAvailable = appsUtil.getFFCProductConfigBySapCode(sapcode);
		if (sapcode && isFFCDataAvailable) {
			const PDPPromise = new Promise((resolve, reject) => {
				let hasThor = this.props.hasThor;
				if (sapcode === 'KCCC') {
					hasThor = false;
				}
				this.props.getPDPDataForCCXUI(this.props.locale, hasThor, sapcode, resolve, reject);
			});
			PDPPromise.then(() => {}, () => {
				if (Url.getParam('action') !== 'install') {
					error(this.props.intl.formatMessage({id: PDPErrorTypes.PDPEndpointDown.messageId}), {msgId: PDPErrorTypes.PDPEndpointDown.errorId,variant: 'default',timeout:7000});
				}
				this.onError(`aem-pdp-${sapcode}`);
				this.props.history.replace(appsUtil.getCCWebURL());
			});
			return PDPPromise;
		}
		if (!isFFCDataAvailable) {
			this.showInvalidProductIdError(appsUtil.getCCWebPathData().product);
		}
		this.props.history.replace(appsUtil.getCCWebURL());
		return Promise.reject(false);
	}

	isProfileRequired() {
		return GrowthUtil.isProfileRequired();
	}

	isDataAvailable() {
		if (AppPickerUtil.isNUJAllAppsExperience() || AppPickerUtil.isNUJSubstancePlanExperience()) {
			return this.props.appPickerContentfulData && this.props.appPickerContentfulData !== null;
		}
		if (AppPickerUtil.isSingleAppPlanNUJExp()) {
			return this.props.appsFFCProductList && this.props.appPickerContentfulData;
		}
		// make ffc etc blocking for nuj ccpp retest
		if (AppPickerUtil.isNujM3PhotoPlanTestExperience()) {
			return this.props.appsFFCProductList && this.props.appsFFCProductList !== null
				&& (!this.isProfileRequired() || this.profileTimeoutOrError || this.profileFetchFinished)
				&& this.props.appPickerContentfulData;
		}
		return this.props.appsFFCProductList && this.props.appsFFCProductList !== null
			&& (!this.isProfileRequired() || this.profileTimeoutOrError || this.profileFetchFinished);
	}

	onError(subtype) {
		const appsAnalytics = new AppsAnalytics(this.props.environment);
		const workflow = (AppPickerUtil.isNUJAppPickerExperience() || AppPickerUtil.isSingleAppPlanNUJExp()) ? 'App Picker' : undefined;
		appsAnalytics.initAnalytics();
		appsAnalytics.onAppsErrorEvent(subtype, workflow);
	}

	loadHomePage() {
		this.props.history.push('/');
	}

	// Dont enter app picker workflow in case of nuj ccpp retest download page
	// instead give the same experience as control download
	shouldRenderAppPickerPage() {
		return AppPickerUtil.isNUJAppPickerExperience() && this.isDataAvailable() && Url.getParam('source') !== CCPP_APP_PICKER_QUERY_PARAM;
	}

	// Render new app picker component.
	renderAppPickerPhotoPlan() {
		CSSUtil.hideTransitionLoader();
		document.title = this.props.intl.formatMessage({id: 'apps.document.title.appPicker'});
		return <AppPickerMain {...this.props} />;
	}

	// New app picker should be rendered only for photo plans when flag is live on mobile devices.
	shouldRenderAppPickerPhotoPlan() {
		return appsUtil.isMobileOrTab() && DeviceDetectionUtil.isIPad() && this.props.routeParams.mainAppsTab === 'starter' && (this.props.routeParams.product === 'ccpp' || this.props.routeParams.product === 'ccppn');
	}

	renderAppsController() {
		const {history, imsData, locale, environment, intl, location} = this.props;
		const appPickerPagePassProps = {
			environment,
			locale,
			imsData,
			intl,
			history,
			location,
			hasThor: this.props.hasThor,
			getFFCDataForAppPicker: this.props.getFFCDataForAppPicker,
			sapCodeDataFetchStatus: this.props.sapCodeDataFetchStatus,
			preFetchedRestAPIResponses: this.props.preFetchedRestAPIResponses
		};

		if (this.isDataAvailable() && this.shouldRenderAppPickerPhotoPlan()) {
			return this.renderAppPickerPhotoPlan(); // mobile app picker for photo plans
		}
		/*
		* CCH-9133
		* Category revamp split event
		* sentCategoryRevampAnalytics: ensures that split event is sent only once
		* customerSegment should be available
		* And user should close starter installation page to fall in this test criteria
		*/
		if (!this.sentCategoryRevampAnalytics && appsUtil.customerSegment && !appsUtil.isPostPurchaseUser()) {
			this.sentCategoryRevampAnalytics = true;
			const appsAnalytics = new AppsAnalytics(this.props.environment);
			appsAnalytics.initAnalytics();
			if (isTestExperience(campaignId.categoryPageRevampTest)) {
				appsAnalytics.genericAnalyticEvent({}, 'split', 'page', undefined, campaignId.categoryPageRevampTest, 'test', undefined, 'Split', 'Apps');
			}
			else if (isControlExperience(campaignId.categoryPageRevampTest)) {
				appsAnalytics.genericAnalyticEvent({}, 'split', 'page', undefined, campaignId.categoryPageRevampTest, 'control', undefined, 'Split', 'Apps');
			}
		}
		appsUtil.isCCXView = !AppPickerUtil.isNUJAppPickerExperience() && !AppPickerUtil.isSingleAppPlanNUJExp();
		return [
			(appsUtil.isCCXView && <CCXUI intl={this.props.intl} />),
			(this.shouldRenderAppPickerPage() && <AppPickerController {...appPickerPagePassProps} />),
			(AppPickerUtil.isSingleAppPlanNUJExp() && this.isDataAvailable() && this.state.isDnldUIReadyToRender && this.dnldUIComponent),
			(this.renderWamConnnectionToast())
		];
	}

	render() {
		if (this.props && this.props.location && this.props.location.pathname && this.props.intl) {
		// Set document title, as per active path
			document.title = appsUtil.getDocumentTitle(this.props.location.pathname, this.props.intl);
		}

		if (this.props.errorType) {
			appsUtil.printTimeEndLog('page_load_time');
			const appsSectionWrapper = document.getElementById('apps_section');
			if (appsSectionWrapper) {
				CSSUtil.addClass(appsSectionWrapper, 'hideWelcomeMessageAppsError');
			}
			CSSUtil.hideTransitionLoader();
			return (
				<ErrorState errorType={this.props.errorType} fromAppController={true}/>
			);
		}
		if (this.isDataAvailable()) {
			if (AppPickerUtil.isNUJAppPickerExperience() || AppPickerUtil.isSingleAppPlanNUJExp()) {
				const footerElem = document.getElementsByClassName('footer-container') && document.getElementsByClassName('footer-container')[0];
				if (footerElem) {
					if (AppPickerUtil.hideLanguageSelectorInFooter()) {
						CSSUtil.addClass(footerElem, 'hideLanguageSelector');
					}
				}
			}
			CSSUtil.hideTransitionLoader();
			AppLoader.setBusy(false);
		}

		return (
			<section id='apps-container' className={`apps-container${appsUtil.isMobileOrTab() ? ' touch-device' : ''}`}>
				{this.renderAppsController()}
			</section>
		);
	}
}

function mapStateToProps(state) {
	return {
		appsPanelSkeletonConfig: state.apps.appsPanelSkeletonConfig,
		sapCodeDataFetchStatus: state.apps.sapCodeDataFetchStatus,
		cdnInfo: state.apps.cdnInfo,
		appsFFCProductList: state.apps.appsFFCProductList,
		appPickerContentfulData: state.apps.appPickerContentfulData,
		entitlementData: state.apps.entitlementData,
		productsData: state.apps.productsData,
		entitledProducts: state.apps.entitledProducts,
		errorType: state.apps.errorType,
		thorAppsList: {...state.apps.products},
		hasThor:state.apps.hasThor
	};
}

export default connect(mapStateToProps, {
	getAppsDataForCCXUI,
	getDataForAppPicker,
	getSingleAppPostPurchaseCVSData,
	getFFCDataForAppPicker,
	getCatalogBannersDataForCCXUI,
	getAppsDataForCCXUIWithSophiaIntegration,
	setThor,
	updateEntitledProducts,
	getPDPDataForCCXUI
})(AppsController);
